import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/faq/PrivacyAndSecurity-q2-01-movil.png")